import { useTranslation } from 'react-i18next';

export function useWhatsNextCardController() {
  const { t } = useTranslation();

  const whatsNextTitle = t('charity.whatsNext.title');

  return { whatsNextTitle };
}
